export default __webpack_public_path__ + "static/media/grid12.233f5357.png";